export enum StructureViewMode {
  New = "new",
  MeteringConcept = "measurementConcept"
}

export const MAX_GENERATOR_WEIGHTING_PER_LOCATION = 1.01;
